import "core-js/modules/es.function.name.js";
import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'SMS_RECHARGE_DETAIL',
        create: 'SMS_RECHARGE_CREATE',
        update: 'SMS_RECHARGE_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'name',
        default: '',
        label: '名称',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'pic',
        default: '',
        label: '图片',
        col: {
          span: 24
        },
        render: function render() {
          return h("d2-pic-uploader", {
            "model": {
              value: _this.form.model.pic,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pic", $$v);
              }
            }
          });
        }
      }, {
        prop: 'project_case_type',
        default: '',
        label: '分类',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "project_type"
            },
            "model": {
              value: _this.form.model.project_case_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "project_case_type", $$v);
              }
            }
          });
        }
      }, {
        prop: 'content',
        default: '',
        label: '内容',
        col: {
          span: 60
        },
        render: function render() {
          return h("d2-quill", {
            "attrs": {
              "vueheight": "600",
              "clearable": true
            },
            "model": {
              value: _this.form.model.content,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "content", $$v);
              }
            }
          });
        }
      }, {
        prop: 'project_case_order',
        default: this.$env.VUE_APP_FORM_SORT_MIN,
        label: '显示排序',
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "min": _this.$env.VUE_APP_FORM_SORT_MIN
            },
            "model": {
              value: _this.form.model.project_case_order,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "project_case_order", $$v);
              }
            }
          });
        }
      }, {
        prop: 'remark',
        default: '',
        label: '备注',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "type": "textarea",
              "autosize": true,
              "clearable": true
            },
            "model": {
              value: _this.form.model.remark,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "remark", $$v);
              }
            }
          });
        }
      }];
    }
  }
};